/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyFxBookAccountDtoSearchResponse } from '../../models/my-fx-book-account-dto-search-response';

export interface SearchMyFxBookAccounts$Plain$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
}

export function searchMyFxBookAccounts$Plain(http: HttpClient, rootUrl: string, params?: SearchMyFxBookAccounts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MyFxBookAccountDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchMyFxBookAccounts$Plain.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MyFxBookAccountDtoSearchResponse>;
    })
  );
}

searchMyFxBookAccounts$Plain.PATH = '/api/my-fx-book/accounts';
